/**
 * AJAX-функциональность для загрузки записей типа "look"
 */
(function($) {
    'use strict';

    // Класс для управления AJAX-загрузкой записей
    class LooksAjaxLoader {
        constructor(container) {
            this.container = $(container);
            this.currentPage = 1;
            this.isLoading = false;
            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            // Обработчик для пагинации
            this.container.on('click', '.looks-pagination a', (e) => {
                e.preventDefault();
                const page = this.getPageFromUrl($(e.currentTarget).attr('href'));
                if (page && page !== this.currentPage) {
                    this.loadPage(page);
                }
            });

            // Обработчик для фильтров
            this.container.on('change', '.looks-filters select, .looks-filters input', () => {
                this.loadPage(1);
            });

            // Обработчик для поиска
            this.container.on('submit', '.looks-search-form', (e) => {
                e.preventDefault();
                this.loadPage(1);
            });
        }

        getPageFromUrl(url) {
            const match = url.match(/paged=(\d+)/);
            return match ? parseInt(match[1]) : 1;
        }

        loadPage(page) {
            if (this.isLoading) return;

            this.currentPage = page;
            this.isLoading = true;

            // Показываем индикатор загрузки
            this.showLoading();

            // Собираем параметры фильтрации
            const filterData = this.getFilterData();

            // Добавляем номер страницы
            filterData.page = page;

            // Выполняем AJAX-запрос
            $.ajax({
                url: looksAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'load_looks',
                    nonce: looksAjax.nonce,
                    ...filterData
                },
                success: (response) => {
                    if (response.success) {
                        this.updateContent(response.data);
                    } else {
                        this.showError(looksAjax.errorText);
                    }
                },
                error: () => {
                    this.showError(looksAjax.errorText);
                },
                complete: () => {
                    this.isLoading = false;
                    this.hideLoading();
                }
            });
        }

        getFilterData() {
            const data = {};

            // Получаем данные из фильтров
            this.container.find('.looks-filters select, .looks-filters input').each(function() {
                const $field = $(this);
                const name = $field.attr('name');
                const value = $field.val();

                if (name && value) {
                    data[name] = value;
                }
            });

            // Получаем данные из формы поиска
            const searchValue = this.container.find('.looks-search-form input[name="search"]').val();
            if (searchValue) {
                data.search = searchValue;
            }

            return data;
        }

        updateContent(data) {
            // Обновляем содержимое
            this.container.find('.looks-grid').html(data.html);

            // Обновляем пагинацию
            this.updatePagination(data.pages);

            // Обновляем счетчик записей
            this.updateCounter(data.total);

            // Прокручиваем к началу списка
            this.scrollToTop();
        }

        updatePagination(pages) {
            const paginationContainer = this.container.find('.looks-pagination');

            if (pages > 1) {
                // Здесь можно обновить пагинацию, если нужно
                // Пока оставляем как есть
            } else {
                paginationContainer.empty();
            }
        }

        updateCounter(total) {
            const counter = this.container.find('.looks-counter');
            if (counter.length) {
                counter.text(`Найдено записей: ${total}`);
            }
        }

        showLoading() {
            const loadingHtml = `
                <div class="looks-loading">
                    <div class="loading-spinner"></div>
                    <p>${looksAjax.loadingText}</p>
                </div>
            `;
            this.container.find('.looks-grid').append(loadingHtml);
        }

        hideLoading() {
            this.container.find('.looks-loading').remove();
        }

        showError(message) {
            const errorHtml = `
                <div class="looks-error">
                    <p>${message}</p>
                </div>
            `;
            this.container.find('.looks-grid').html(errorHtml);
        }

        scrollToTop() {
            // Прокручиваем к началу каталога при смене категории
            const catalogSection = document.querySelector('.catalog');
            if (catalogSection) {
                const offset = catalogSection.offsetTop - 100; // Отступ от верха
                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            } else {
                // Fallback: прокручиваем к началу контейнера
                const offset = this.container.offset().top - 100;
                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            }
        }
    }

    // Инициализация при загрузке документа
    // Закомментировано для избежания конфликтов с main-function.js
    // $(document).ready(function() {
    //     // Инициализируем загрузчик для всех контейнеров с классом .looks-list
    //     $('.looks-list').each(function() {
    //         new LooksAjaxLoader(this);
    //     });
    // });

    // Класс для управления кнопкой "Загрузить еще"
    class LoadMoreButton {
        constructor(container) {
            this.container = $(container);
            this.loadMoreBtn = this.container.find('.load-more-btn');
            this.looksGrid = this.container.find('.looks-grid');
            this.currentPage = parseInt(this.loadMoreBtn.data('page')) || 2;
            this.totalPages = parseInt(this.loadMoreBtn.data('total-pages')) || 1;
            this.isLoading = false;
            this.init();
        }

        init() {
            this.bindEvents();
        }

        bindEvents() {
            this.loadMoreBtn.on('click', (e) => {
                e.preventDefault();
                this.loadMore();
            });
        }

        loadMore() {
            if (this.isLoading || this.currentPage > this.totalPages) {
                return;
            }

            this.isLoading = true;
            this.showLoading();

            // Собираем параметры фильтрации
            const filterData = this.getFilterData();
            filterData.page = this.currentPage;
            filterData.posts_per_page = 18; // Загружаем по 18 постов

            // Выполняем AJAX-запрос
            $.ajax({
                url: looksAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'load_looks',
                    nonce: looksAjax.nonce,
                    ...filterData
                },
                success: (response) => {
                    if (response.success) {
                        this.appendContent(response.data);
                        this.updateButton(response.data);
                    } else {
                        this.showError(looksAjax.errorText);
                    }
                },
                error: () => {
                    this.showError(looksAjax.errorText);
                },
                complete: () => {
                    this.isLoading = false;
                    this.hideLoading();
                }
            });
        }

        getFilterData() {
            const data = {};

            // Получаем параметры фильтрации из URL или других источников
            const urlParams = new URLSearchParams(window.location.search);

            // Получаем категорию из URL
            const category = urlParams.get('category');
            if (category) {
                data.look_category_slug = category;
            }

            // Получаем данные из фильтров на странице
            $('.catalog__filters').find('select, input').each(function() {
                const $field = $(this);
                const name = $field.attr('name') || $field.data('filter');
                const value = $field.val();

                if (name && value) {
                    // Преобразуем имена фильтров в нужный формат
                    switch(name) {
                        case 'brand_filter':
                            data.brand = value;
                            break;
                        case 'style_filter':
                            data.style = value;
                            break;
                        case 'color_filter':
                            data.color = value;
                            break;
                        case 'stylist_filter':
                            data.stylist = value;
                            break;
                        default:
                            data[name] = value;
                    }
                }
            });

            return data;
        }

        appendContent(data) {
            // Добавляем новый контент к существующему
            this.looksGrid.append(data.html);
        }

        updateButton(data) {
            // Обновляем атрибуты кнопки
            this.loadMoreBtn.attr('data-page', this.currentPage + 1);

            // Проверяем, есть ли еще страницы
            if (this.currentPage >= this.totalPages) {
                this.hideButton();
            } else {
                this.currentPage++;
            }
        }

        showLoading() {
            this.loadMoreBtn.prop('disabled', true);
            this.loadMoreBtn.find('.load-more-text').hide();
            this.loadMoreBtn.find('.load-more-spinner').show();
        }

        hideLoading() {
            this.loadMoreBtn.prop('disabled', false);
            this.loadMoreBtn.find('.load-more-text').show();
            this.loadMoreBtn.find('.load-more-spinner').hide();
        }

        hideButton() {
            this.loadMoreBtn.closest('.load-more-container').fadeOut();
        }

        showError(message) {
            const errorHtml = `
                <div class="load-more-error">
                    <p>${message}</p>
                </div>
            `;
            this.loadMoreBtn.closest('.load-more-container').html(errorHtml);
        }
    }

    // Инициализация при загрузке документа
    // Закомментировано для избежания конфликтов с main-function.js
    // $(document).ready(function() {
    //     // Инициализируем загрузчик для всех контейнеров с классом .looks-list
    //     $('.looks-list').each(function() {
    //         new LooksAjaxLoader(this);
    //
    //         // Инициализируем кнопку "Загрузить еще", если она есть
    //         if ($(this).find('.load-more-btn').length) {
    //             new LoadMoreButton(this);
    //         }
    //     });
    // });

    // Экспортируем классы для использования в других скриптах
    window.LooksAjaxLoader = LooksAjaxLoader;
    window.LoadMoreButton = LoadMoreButton;

})(jQuery);
